import React from "react";
import { Link } from "react-router-dom";
import goalGuruIcon from "../assets/images/goal_guru_icon.webp";
import StoreBadges from "./StoreBadges";
import { SOCIAL_PROFILES } from "../data/socialProfiles";
import "../assets/styles/Footer.scss";

function Footer() {
  return (
    <footer>
      <div className="footer-gradient-line" />

      <div className="footer-inner">
        <div className="footer-brand">
          <img src={goalGuruIcon} width={900} height={900} alt="Goal Guru Logo" className="footer-logo-img" loading="lazy" />
          <h2 className="footer-brand-name">Goal Guru</h2>
          <p className="footer-tagline">
            Your Ultimate Football Tracking App
          </p>
          <ul className="footer-social" aria-label="Goal Guru on social media">
            {SOCIAL_PROFILES.map(({ name, url, icon: Icon }) => (
              <li key={name}>
                <a href={url} target="_blank" rel="noopener noreferrer" aria-label={`Goal Guru on ${name}`}>
                  <Icon aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-nav">
          <span className="footer-nav-label">Product</span>
          <Link to="/pricing/">Pricing</Link>
          <Link to="/faq/">FAQ</Link>
          <Link to="/blog/">Blog</Link>
          <Link to="/live-football-alerts/">Live Alerts</Link>
          <Link to="/smart-football-notifications/">Smart Notifications</Link>
        </div>

        <div className="footer-nav">
          <span className="footer-nav-label">Legal</span>
          <Link to="/privacy-policy/">Privacy Policy</Link>
          <Link to="/terms-conditions/">Terms &amp; Conditions</Link>
        </div>

        <div className="footer-download">
          <span className="footer-nav-label">Download</span>
          <StoreBadges height={46} className="footer-badges" />
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-about">
          Goal Guru is a personalized football analytics platform for fans and
          analysts who want more than a scoreline. Track live matches across
          hundreds of leagues, build custom Smart Alerts around the exact
          conditions you care about, and get AI-generated match analysis from
          Guru Vision — all tailored to what you actually follow. Download
          Goal Guru on iOS or Android and see the game the way you want to.
        </p>
        <p className="copyright">© 2026 Goal Guru. All rights reserved.</p>
        <p className="footer-disclaimer">
          Goal Guru provides football data insights and does not offer
          betting or wagering functionality.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
